export default 'https://tme.understood.org/assets/spider_web.aeae6cf9.glb'